// useAuth.js
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateAccount } from "../actions/account";
import * as authService from "../services/auth";
import { jwtDecode } from "jwt-decode";

export const useAuth = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const signin = async ({ email, password }) => {
        const response = await authService.signIn({ email, password });

        if (response) {
            dispatch(updateAccount(response));
            navigate("/");
            return response;
        }

        return false;
    };

    const signup = async ({ name, email, password }) => {
        const response = await authService.signUp({ name, email, password });

        if (response) {
            dispatch(updateAccount(response));
            navigate("/");
            return response;
        }

        return false;
    };

    const signinWithGoogle = async (credential) => {
        const decoded = jwtDecode(credential.credential);
        const userData = {
            name: decoded.name,
            email: decoded.email,
            picture: decoded.picture,
        };

        const response = await authService.signInSocialMedia(userData);

        if (response) {
            dispatch(updateAccount(response));
            navigate("/");
            return response;
        }

        return false;
    };

    return { signin, signup, signinWithGoogle };
};
